// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'

import {
  TabbedView,
  SvgIcon,
  EmployerCommunications,
  EmployerBulkSMSAudiences,
  EmployerBulkSMSMessageList,
  EmployerBulkSMSMessageCompose
} from '../../components'

const QUERY_EMPLOYER_IDENTITY = gql`
  query($id: ID!) {
    employer(id: $id) {
      id
      identity {
        id
      }
    }
  }
`


const getFiltersFromQueryString = (queryString) => {
  let queryParams = qs.parse(queryString)

  let filters = Object.assign(
    {},
    ...Object.keys(queryParams).map(key => (
      key === 'tab'
        ? { currentTab: parseInt(queryParams[key], 10) }
        : null
    ))
  )
  return filters
}


class EmployerSMS extends Component {
  static propTypes = {
    fromAddr: PropTypes.string,
    toAddr: PropTypes.string,
    title: PropTypes.string,
    noStatusFilter: PropTypes.bool
  }

  static defaultProps = {
    title: <div className='slds-grid' style={{ alignItems: 'center' }}>
        <SvgIcon
          variant='utility'
          symbol='comments'
          colour='light'
          size='large'
        />
        <div className='slds-m-left_medium u-font-size-x-large u-text-caps'>
          SMS
        </div>
      </div>
  }

  state = {
    currentTab: 0
  }

  componentDidMount() {
    if (this.props.location.search.length === 0) {
      this.setQueryString()
    } else {
      this.setState(getFiltersFromQueryString(this.props.location.search))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState(getFiltersFromQueryString(this.props.location.search))
    }
  }

  setQueryString = () => {
    this.props.history.push({
      search: qs.stringify({
        tab: this.state.currentTab
      })
    })
  }

  changeViewAndSearchParams = (tabIndex) => {
    this.props.history.replace({ search: '' })  // clear query string search params

    this.setState({
      currentTab: tabIndex  // change to chosen tab
    }, this.setQueryString)
  }

  displayAssociatedContent = (currentTab) => {
    const MESSAGES = 0
    const BULK_MESSAGES = 1
    const BULK_COMPOSE = 2
    const AUDIENCES = 3

    const employerId = this.props.match.params.employerId
    const currentPath = this.props.location.pathname

    return (
      <Query query={QUERY_EMPLOYER_IDENTITY} variables={{ id: this.props.match.params.employerId }}>
        {({ loading, error, data }) => {
          if (loading || error) {
            return null
          }

          const employerIdentityId = data.employer.identity.id

          if (currentTab === MESSAGES) {
            return (
              <EmployerCommunications
                employerIdentityId={employerIdentityId}
                communicationType='SMS'
                urlPath={currentPath}
                title={null}
                lockOnCommunicationType={true}
              />
            )
          }

          if (currentTab === BULK_MESSAGES) {
            return (
              <EmployerBulkSMSMessageList employerId={employerId} />
            )
          }

          if (currentTab === BULK_COMPOSE) {
            return (
              <EmployerBulkSMSMessageCompose
                employerId={employerId}
                employerIdentityId={employerIdentityId}
                goToBulkMessageDetailPage={messageId => this.props.history.push(`/employer/${employerId}/communications/bulk/${messageId}`)}
                goToAudienceListingPage={() => this.props.history.push(`/employer/${employerId}/communications?tab=3`)}
              />
            )
          }

          if (currentTab === AUDIENCES) {
            return (
              <EmployerBulkSMSAudiences
                employerId={employerId}
                employerIdentityId={employerIdentityId}
                goToAudienceDetailPage={audienceId => this.props.history.push(`/employer/${employerId}/communications/bulk/audience/${audienceId}`)}
              />
            )
          }
        }}
      </Query>
    )


  }

  render() {
    const tabs = ['Messages', 'Bulk messages', 'Compose bulk message', 'Audiences']

    return (
      <div className='slds-grow slds-scrollable_y' role="main">
        <div className='slds-grid slds-wrap slds-size_1-of-1'>
          <div className='tab-nav slds-size_1-of-1 u-bg-color-white product-listing-page-header'>
            {this.props.title !== null &&
              <div className='slds-m-top_x-small slds-m-bottom_xxx-small slds-p-left_large product-listing-page-header_title'>
                {this.props.title}
              </div>
            }
            {this.props.noStatusFilter
              ? null
              : <TabbedView
                  tabs={tabs}
                  contents={[]}
                  selectedTab={this.state.currentTab}
                  onClick={this.changeViewAndSearchParams}
                  tabsClassName='slds-align_absolute-center product-listing-page-header_tabs'
                />
            }
          </div>
          {this.displayAssociatedContent(this.state.currentTab)}
        </div>
      </div>
    )
  }
}

export default withRouter(EmployerSMS)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployerSMS.js